import * as React from 'react';
import RoutePrivate from '../router/RoutePrivate';

import CompaniesPage from './CompaniesPage';

export default function getRoutes(isLoggedIn: boolean) {
    return [<RoutePrivate key="companiess" path="/companies" component={CompaniesPage} isLoggedIn={isLoggedIn} />];
}



// WEBPACK FOOTER //
// ./src/components/companies/Company.Routes.tsx